import React, {Component} from 'react';
import {Form, FormGroup, Checkbox, ControlLabel, FormControl, Button} from 'react-bootstrap';
export default class TableCustomEditor extends React.Component {
    constructor(props) {
        super(props);
        console.log('props in TableCustomEditor', props);
        this.state={
            valueSaved:false,
            currentRecordData:props.currentRecordData,
            textValue:props.defaultValue
        }
     }


    render() {
       if (this.state.valueSaved){
           return <div className="text-center">{this.state.textValue}</div>
       }
        return   <div>
            <FormControl type="text"
                         onChange={(e) => this.setState({
                             'textValue': e.target.value
                         })}
                         value={this.state.textValue }
                         placeholder=" "/>
            <Button className="top10 pull-right   btn btn-primary "

                    type="button"
                    onClick={()=> {
                        this.props.onUpdate({
                            'row': this.props.row,
                            'cellValue': this.state.textValue,
                            'cellName': this.props.cellName
                        })
                        this.setState({valueSaved:true})
                    }}   >
                Save
            </Button>

        </div>

    }
}
